import { NgClass, NgIf } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ItemsHelperService } from 'src/app/services/helpers/items-helper.service';

@Component({
  selector: 'app-listers',
  standalone: true,
  imports: [NgIf, NgClass, TranslateModule],
  templateUrl: './listers.component.html'
})
export class ListersComponent {
  @Output() closemodal = new EventEmitter<boolean>();
  @Input() followingType = false;

  constructor(private itemsHelperService: ItemsHelperService) { }

  selectFollowinType(type: boolean): void {
    this.followingType = type;
    this.itemsHelperService.selectFtype(this.followingType);
  }
}
